import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mankhurdtopunecab() {



  const cardData = {


  keyword: "Mankhurd to Pune Cab",

  headingDescription: "Trustline Cab provides reliable Mankhurd to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family trips, industrial visits, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey from Mankhurd to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained cars, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Mankhurd to Pune taxi services.",

  topPlaces: [
    {
      title: "Hinjewadi",
      description: "Hinjewadi is Pune's leading IT destination, home to Rajiv Gandhi Infotech Park, multinational companies, software firms, and corporate campuses. It is one of the most popular destinations for professionals and business travelers."
    },
    {
      title: "Kharadi",
      description: "Kharadi is a major IT and business hub in Pune featuring EON IT Park, corporate offices, technology companies, hotels, and commercial spaces. It attracts professionals from across Maharashtra."
    },
    {
      title: "Hadapsar",
      description: "Hadapsar is a prominent commercial locality known for Magarpatta City, IT parks, business offices, shopping malls, educational institutions, and excellent connectivity across Pune."
    },
    {
      title: "Pimple Saudagar",
      description: "Pimple Saudagar is a developed residential and commercial area offering premium housing projects, restaurants, shopping destinations, and convenient connectivity to Pimpri Chinchwad and Pune IT corridors."
    },
    {
      title: "Talegaon MIDC",
      description: "Talegaon MIDC is an important industrial area near Pune, featuring automobile companies, manufacturing units, logistics centers, and corporate facilities. It is a preferred destination for industrial travel."
    },
    {
      title: "Viman Nagar",
      description: "Viman Nagar is a premium Pune locality near the airport, known for IT companies, hotels, shopping malls, restaurants, and commercial developments. It is popular among business travelers and visitors."
    },
    {
      title: "Shaniwar Wada",
      description: "Shaniwar Wada is Pune's famous historical landmark, known for its Maratha architecture, cultural heritage, and historical importance. It is one of the top sightseeing attractions in the city."
    },
    {
      title: "Sinhagad Fort",
      description: "Sinhagad Fort is a historic hill fort near Pune, famous for trekking trails, scenic mountain views, rich Maratha history, and beautiful natural surroundings. It is a popular destination for adventure lovers."
    },
    {
      title: "Pawna Lake",
      description: "Pawna Lake is a scenic destination near Pune known for lakeside camping, mountain views, boating, and peaceful surroundings. It is a popular weekend getaway for families and nature enthusiasts."
    },
    {
      title: "Rajmachi Fort",
      description: "Rajmachi Fort is a historic trekking destination near Lonavala offering scenic landscapes, mountain trails, waterfalls, and breathtaking views. It is a favorite spot for trekkers and photographers."
    }
  ],






"services": [
  {
    "name": "Mankhurd to Pune Cab Service",
    "description": "Book Mankhurd to Pune Cab Service with clean AC Sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles for safe and comfortable intercity travel. Enjoy fixed fares, professional chauffeurs, doorstep pickup, online booking, luggage assistance, one way and round trip options, corporate travel, family trips, airport transfers, and reliable 24x7 customer support."
  },
  {
    "name": "Mankhurd to Pimpri Cab",
    "description": "Reserve Mankhurd to Pimpri Cab with experienced drivers, comfortable AC vehicles, transparent pricing, and reliable outstation transportation for business and family travel."
  },
  {
    "name": "Mankhurd to Pune One Way Cab",
    "description": "Book Mankhurd to Pune One Way Cab with affordable fares, instant confirmation, clean vehicles, professional chauffeurs, and convenient doorstep pickup."
  },
  {
    "name": "Chembur to Pune Car Fare",
    "description": "Check Chembur to Pune Car Fare with transparent pricing, multiple vehicle options, fixed packages, and comfortable chauffeur-driven travel."
  },
  {
    "name": "Belapur to Pune by Taxi",
    "description": "Travel from Belapur to Pune by Taxi with premium AC cars, experienced drivers, affordable fares, and reliable one way and round trip services."
  },
  {
    "name": "Belapur to Pune One Way Cab",
    "description": "Choose Belapur to Pune One Way Cab for direct travel with fixed pricing, professional chauffeurs, comfortable vehicles, and online booking facility."
  },
  {
    "name": "Belapur to Pimpri Chinchwad Cab",
    "description": "Book Belapur to Pimpri Chinchwad Cab with clean AC vehicles, experienced drivers, transparent fares, and smooth intercity travel."
  },
  {
    "name": "Belapur to Baner Cab Fare",
    "description": "Find Belapur to Baner Cab Fare with affordable rates, Sedan, Ertiga, Innova Crysta, and SUV options for comfortable journeys."
  },
  {
    "name": "Seawoods to Pune Cab Fare",
    "description": "Check Seawoods to Pune Cab Fare with fixed pricing, multiple vehicle choices, professional chauffeurs, and reliable outstation cab services."
  },
  {
    "name": "Seawoods to Pune Station Cab",
    "description": "Book Seawoods to Pune Station Cab for punctual railway station pickup and drop with comfortable AC vehicles and experienced drivers."
  },
  {
    "name": "Sanpada to Pune Cab Service",
    "description": "Choose Sanpada to Pune Cab Service for safe and affordable intercity travel with clean cars, fixed fares, and professional chauffeur support."
  },
  {
    "name": "Ghansoli to Pune Cab",
    "description": "Reserve Ghansoli to Pune Cab with reliable drivers, AC vehicles, affordable packages, and comfortable travel for business and family needs."
  },
  {
    "name": "Mumbai to Pune Taxi Booking",
    "description": "Complete Mumbai to Pune Taxi Booking online with instant confirmation, multiple cab options, transparent pricing, and reliable customer assistance."
  },
  {
    "name": "Best Taxi Service in Mankhurd",
    "description": "Choose the Best Taxi Service in Mankhurd with professional chauffeurs, clean AC cars, affordable fares, online booking, and dependable customer support."
  },
  {
    "name": "Best Taxi Service in Mankhurd Contact Number",
    "description": "Contact our Best Taxi Service in Mankhurd for instant booking assistance, fare details, vehicle availability, and 24x7 travel support."
  },
  {
    "name": "Outstation Taxi Service in Mankhurd",
    "description": "Book Outstation Taxi Service in Mankhurd for Pune, Mumbai Airport, Nashik, Lonavala, Shirdi, and other destinations with comfortable vehicles and fixed fares."
  },
  {
    "name": "Outstation Taxi Service in Mankhurd Price",
    "description": "Check Outstation Taxi Service in Mankhurd Price with transparent packages, affordable rates, multiple vehicle options, and no hidden charges."
  },
  {
    "name": "Outstation Cab Service in Mumbai",
    "description": "Choose Outstation Cab Service in Mumbai for reliable long-distance travel with premium vehicles, experienced drivers, and 24x7 availability."
  },
  {
    "name": "Mankhurd to Pune Cab",
    "description": "Book Mankhurd to Pune Cab with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for comfortable highway travel, airport transfers, family trips, and corporate journeys."
  },
  {
    "name": "Mankhurd to Pune Cabs",
    "description": "Reserve Mankhurd to Pune Cabs with multiple vehicle choices, fixed fares, professional drivers, and convenient one way or round trip travel."
  },
  {
    "name": "Mankhurd to Pune Taxi Service",
    "description": "Travel with Mankhurd to Pune Taxi Service featuring clean AC vehicles, transparent pricing, luggage assistance, and smooth intercity transportation."
  },
  {
    "name": "Mankhurd to Pune One Way Cab",
    "description": "Choose Mankhurd to Pune One Way Cab for affordable direct travel with experienced chauffeurs, fixed fares, and comfortable vehicles."
  },
  {
    "name": "Mankhurd to Pune Taxi Fare",
    "description": "Check Mankhurd to Pune Taxi Fare with affordable packages, transparent billing, multiple cab categories, and no hidden costs."
  },
  {
    "name": "Mankhurd to Pune Cab Booking",
    "description": "Complete Mankhurd to Pune Cab Booking online with secure reservations, instant confirmation, flexible pickup timing, and professional drivers."
  },
  {
    "name": "Cab from Mankhurd to Pune",
    "description": "Book Cab from Mankhurd to Pune for business travel, family vacations, airport transfers, and comfortable chauffeur-driven journeys."
  },
  {
    "name": "Mankhurd to Pune Car Rental",
    "description": "Hire Mankhurd to Pune Car Rental with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for one way, round trip, and corporate travel."
  },
  {
    "name": "Mankhurd to Pune Taxi Booking Online",
    "description": "Reserve Mankhurd to Pune Taxi Booking Online with quick confirmation, transparent fares, multiple vehicle options, and 24x7 customer support."
  },
  {
    "name": "Cheap Cab Mankhurd to Pune",
    "description": "Book Cheap Cab Mankhurd to Pune with economical fares, clean vehicles, experienced drivers, and dependable outstation transportation."
  },
  {
    "name": "Mankhurd to Pune Outstation Cab",
    "description": "Choose Mankhurd to Pune Outstation Cab for safe long-distance travel with fixed pricing, premium vehicles, and professional chauffeurs."
  },
  {
    "name": "Mankhurd to Pune AC Taxi Service",
    "description": "Travel comfortably with Mankhurd to Pune AC Taxi Service featuring air-conditioned vehicles, affordable pricing, and smooth highway journeys."
  },
  {
    "name": "Mankhurd to Pune Innova Cab",
    "description": "Book Mankhurd to Pune Innova Cab for spacious family travel, corporate trips, airport transfers, group tours, and premium comfort."
  },
  {
    "name": "Mankhurd to Pune Cab Price",
    "description": "Check Mankhurd to Pune Cab Price with transparent fare estimates, fixed packages, multiple vehicle options, and affordable travel solutions."
  }
],

"tableData": [
  ["Mankhurd to Pune Cab Service", "Mankhurd to Pimpri Cab"],
  ["Mankhurd to Pune One Way Cab", "Chembur to Pune Car Fare"],
  ["Belapur to Pune by Taxi", "Belapur to Pune One Way Cab"],
  ["Belapur to Pimpri Chinchwad Cab", "Belapur to Baner Cab Fare"],
  ["Seawoods to Pune Cab Fare", "Seawoods to Pune Station Cab"],
  ["Sanpada to Pune Cab Service", "Ghansoli to Pune Cab"],
  ["Mumbai to Pune Taxi Booking", "Best Taxi Service in Mankhurd"],
  ["Best Taxi Service in Mankhurd Contact Number", "Outstation Taxi Service in Mankhurd"],
  ["Outstation Taxi Service in Mankhurd Price", "Outstation Cab Service in Mumbai"],
  ["Mankhurd to Pune Cab", "Mankhurd to Pune Cabs"],
  ["Mankhurd to Pune Cab Service", "Mankhurd to Pune Taxi Service"],
  ["Mankhurd to Pune One Way Cab", "Mankhurd to Pune Taxi Fare"],
  ["Mankhurd to Pune Cab Booking", "Cab from Mankhurd to Pune"],
  ["Mankhurd to Pune Car Rental", "Mankhurd to Pune Taxi Booking Online"],
  ["Cheap Cab Mankhurd to Pune", "Mankhurd to Pune Outstation Cab"],
  ["Mankhurd to Pune AC Taxi Service", "Mankhurd to Pune Innova Cab"],
  ["Mankhurd to Pune Cab Price", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Mankhurd to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab provides dependable Mankhurd to Pune cab services with comfortable vehicles, professional chauffeurs, and smooth intercity travel solutions."
  },
  {
    WhyChooseheading: "Convenient Pickup from Mankhurd",
    WhyChoosedescription: "Get easy pickup from Mankhurd East, Mankhurd West, railway station, offices, hotels, and residential areas with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Safe & Smooth Mumbai Pune Journey",
    WhyChoosedescription: "Our experienced drivers ensure a secure and comfortable ride with excellent knowledge of Mumbai–Pune Expressway and highway routes."
  },
  {
    WhyChooseheading: "Wide Range of Travel Vehicles",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "Transparent Cab Fare",
    WhyChoosedescription: "Get clear pricing details before booking with competitive rates and no hidden charges for your Mankhurd to Pune journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Book one-way cabs, return trips, or customized travel plans according to your schedule and destination needs."
  },
  {
    WhyChooseheading: "Perfect for Corporate & Personal Travel",
    WhyChoosedescription: "Our Mankhurd to Pune cabs are suitable for office travel, business meetings, airport transfers, family trips, and personal journeys."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Assistance",
    WhyChoosedescription: "Our support team is available anytime to help with bookings, vehicle selection, and travel assistance for a hassle-free experience."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Mankhurd to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Mankhurd to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Mankhurd to Pune?",
    answer: "Yes, one-way cab services are available with convenient pickup from Mankhurd and direct drop anywhere in Pune."
  },
  {
    question: "Do you provide pickup from Mankhurd Railway Station?",
    answer: "Yes, we provide pickup from Mankhurd Railway Station, residential areas, offices, hotels, and nearby Mumbai locations."
  },
  {
    question: "Which vehicles are available for Mankhurd to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable travel."
  },
  {
    question: "Is Mankhurd to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7, allowing you to travel according to your preferred timing."
  },
  {
    question: "Can I reserve a return cab from Pune to Mankhurd?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Mankhurd."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed booking quotation."
  },
  {
    question: "Should I book my Mankhurd to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and preferred pickup timing."
  },
  {
    question: "Do you provide Mankhurd to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for corporate meetings, employee transportation, client visits, and business travel."
  },
  {
    question: "How can I book Mankhurd to Pune Cab with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Shinde",
    feedback: "Trustline Travels provided a smooth Mankhurd to Pune cab experience with timely pickup, a clean vehicle, and a professional driver. The complete journey was comfortable and reliable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback: "The booking process was quick and the service was excellent. The driver was polite, the cab was comfortable, and our journey from Mankhurd to Pune was safe and stress-free.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mankhurd to Pune Cab",
  "image": "https://www.trustlinetravels.com/assets/images/mankhurd-to-pune-cab.webp",
  "description":
    "Book Mankhurd to Pune Cab with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Mankhurd, Chembur, Belapur, Seawoods, and nearby Navi Mumbai locations to Pune, Pimpri Chinchwad, Baner, and all Pune destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/mankhurd-to-pune-cab"
  }
};




  return (
    <div>

<Helmet>
  <title>Mankhurd to Pune Cab | One Way Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Mankhurd to Pune Cab with Trustline Travels for reliable one-way and round-trip taxi services. Travel from Mankhurd, Chembur, Belapur, Seawoods, and nearby Navi Mumbai locations to Pune, Pimpri Chinchwad, Baner, and all Pune destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="mankhurd to pune cab service, mankhurd to pimpri cab, mankhurd to pune one way cab, chembur to pune car fare, belapur to pune by taxi, belapur to pune one way cab, belapur to pimpri chinchwad cab, belapur to baner cab fare, seawoods to pune cab, Mankhurd to Pune Cab, Mankhurd Pune Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mankhurdtopunecab;